"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.width = exports.penciler = exports.letterer = exports.inker = exports.height = exports.depth = exports.colorist = exports.artworkSurface = exports.birthPlace = exports.birthDate = exports.givenName = exports.familyName = exports.datePublished = exports.dateCreated = exports.artMedium = exports.artist = exports.artform = exports.artEdition = exports.Observation = exports.MediaObject = exports.Comment = exports.Answer = exports.PlayAction = exports.UpdateAction = exports.SubscribeAction = exports.Conversation = exports.VideoObject = exports.Apartment = exports.Room = exports.Accommodation = exports.Organization = exports.BefriendAction = exports.JoinAction = exports.Event = exports.Country = exports.Place = exports.City = exports.House = exports.Code = exports.ImageObject = exports.Action = exports.PropertyValue = exports.Project = exports.VisualArtwork = exports.Person = exports.CreativeWork = exports.DataType = exports._self = exports.ns = exports.loadData = void 0;
exports.startTime = exports.areaServed = exports.postalCode = exports.founder = exports.members = exports.endTime = exports.honorificPrefix = exports.member = exports.address = exports.superEvent = exports.legalName = exports.email = exports.faxNumber = exports.object = exports.participant = exports.agent = exports.event = exports.location = exports.attendee = exports.affiliation = exports.endDate = exports.startDate = exports.telephone = exports.about = exports.accommodationCategory = exports.actionStatus = exports.longitude = exports.latitude = exports.contentUrl = exports.Thing = exports.Intangible = exports.AdministrativeArea = exports.containsPlace = exports.containedInPlace = exports.codeValue = exports.url = exports.subjectOf = exports.sameAs = exports.potentialAction = exports.name = exports.mainEntityOfPage = exports.image = exports.identifier = exports.disambiguatingDescription = exports.description = exports.homeLocation = exports.hasOccupation = exports.gender = exports.alternateName = exports.additionalType = void 0;
exports.schema = exports.streetAddress = exports.addressLocality = exports.addressRegion = exports.addressCountry = exports.dateModified = exports.dateDeleted = exports.item = exports.observationAbout = exports.observationDate = exports.variableMeasured = exports.propertyID = exports.value = exports.creditText = exports.copyrightNotice = exports.usageInfo = exports.parentItem = exports.teamID = void 0;
const JSONLD_1 = require("lincd-jsonld/lib/utils/JSONLD");
const NameSpace_1 = require("lincd/lib/utils/NameSpace");
const package_1 = require("../package");
const _this = __importStar(require("./schema"));
var loadData = () => {
    //TODO: switch to ESM and turn this into a dynamic import that actuall splits bundles
    //for now we dont import data because this file is massive
    // return JSONLD.parsePromises(import('../data/schema.json'), import('../data/schema-added.json'));
    return JSONLD_1.JSONLD.parsePromises(Promise.resolve().then(() => __importStar(require('../data/schema-added.json'))));
};
exports.loadData = loadData;
//NOTE: we have changed the usual namespace https://schema.org/ to http://schema.org/ because tools like jsonld will convert all URI's to HTTP
//for now, our approach is therefor to convert to & use http versions only. schema.json has been adjusted too, and all namespaces in other files should use http://schema.org
exports.ns = (0, NameSpace_1.createNameSpace)('http://schema.org/');
exports._self = (0, exports.ns)('');
// Classes
exports.DataType = (0, exports.ns)('DataType');
exports.CreativeWork = (0, exports.ns)('CreativeWork');
exports.Person = (0, exports.ns)('Person');
exports.VisualArtwork = (0, exports.ns)('VisualArtwork');
exports.Project = (0, exports.ns)('Project');
exports.PropertyValue = (0, exports.ns)('PropertyValue');
exports.Action = (0, exports.ns)('Action');
exports.ImageObject = (0, exports.ns)('ImageObject');
exports.Code = (0, exports.ns)('Code');
exports.House = (0, exports.ns)('House');
exports.City = (0, exports.ns)('City');
exports.Place = (0, exports.ns)('Place');
exports.Country = (0, exports.ns)('Country');
exports.Event = (0, exports.ns)('Event');
exports.JoinAction = (0, exports.ns)('JoinAction');
exports.BefriendAction = (0, exports.ns)('BefriendAction');
exports.Organization = (0, exports.ns)('Organization');
exports.Accommodation = (0, exports.ns)('Accommodation');
exports.Room = (0, exports.ns)('Room');
exports.Apartment = (0, exports.ns)('Apartment');
exports.VideoObject = (0, exports.ns)('VideoObject');
exports.Conversation = (0, exports.ns)('Conversation');
exports.SubscribeAction = (0, exports.ns)('SubscribeAction');
exports.UpdateAction = (0, exports.ns)('UpdateAction');
exports.PlayAction = (0, exports.ns)('PlayAction');
exports.Answer = (0, exports.ns)('Answer');
exports.Comment = (0, exports.ns)('Comment');
exports.MediaObject = (0, exports.ns)('MediaObject');
exports.Observation = (0, exports.ns)('Observation');
// Properties
exports.artEdition = (0, exports.ns)('artEdition');
exports.artform = (0, exports.ns)('artform');
exports.artist = (0, exports.ns)('artist');
exports.artMedium = (0, exports.ns)('artMedium');
exports.dateCreated = (0, exports.ns)('dateCreated');
exports.datePublished = (0, exports.ns)('datePublished');
exports.familyName = (0, exports.ns)('familyName');
exports.givenName = (0, exports.ns)('givenName');
exports.birthDate = (0, exports.ns)('birthDate');
exports.birthPlace = (0, exports.ns)('birthPlace');
exports.artworkSurface = (0, exports.ns)('artworkSurface');
exports.colorist = (0, exports.ns)('colorist');
exports.depth = (0, exports.ns)('depth');
exports.height = (0, exports.ns)('height');
exports.inker = (0, exports.ns)('inker');
exports.letterer = (0, exports.ns)('letterer');
exports.penciler = (0, exports.ns)('penciler');
exports.width = (0, exports.ns)('width');
exports.additionalType = (0, exports.ns)('additionalType');
exports.alternateName = (0, exports.ns)('alternateName');
exports.gender = (0, exports.ns)('gender');
exports.hasOccupation = (0, exports.ns)('hasOccupation');
exports.homeLocation = (0, exports.ns)('homeLocation');
exports.description = (0, exports.ns)('description');
exports.disambiguatingDescription = (0, exports.ns)('disambiguatingDescription');
exports.identifier = (0, exports.ns)('identifier');
exports.image = (0, exports.ns)('image');
exports.mainEntityOfPage = (0, exports.ns)('mainEntityOfPage');
exports.name = (0, exports.ns)('name');
exports.potentialAction = (0, exports.ns)('potentialAction');
exports.sameAs = (0, exports.ns)('sameAs');
exports.subjectOf = (0, exports.ns)('subjectOf');
exports.url = (0, exports.ns)('url');
exports.codeValue = (0, exports.ns)('codeValue');
exports.containedInPlace = (0, exports.ns)('containedInPlace');
exports.containsPlace = (0, exports.ns)('containsPlace');
exports.AdministrativeArea = (0, exports.ns)('AdministrativeArea');
exports.Intangible = (0, exports.ns)('Intangible');
exports.Thing = (0, exports.ns)('Thing');
exports.contentUrl = (0, exports.ns)('contentUrl');
exports.latitude = (0, exports.ns)('latitude');
exports.longitude = (0, exports.ns)('longitude');
exports.actionStatus = (0, exports.ns)('actionStatus');
exports.accommodationCategory = (0, exports.ns)('accommodationCategory');
exports.about = (0, exports.ns)('about');
exports.telephone = (0, exports.ns)('telephone');
exports.startDate = (0, exports.ns)('startDate');
exports.endDate = (0, exports.ns)('endDate');
exports.affiliation = (0, exports.ns)('affiliation');
exports.attendee = (0, exports.ns)('attendee');
exports.location = (0, exports.ns)('location');
exports.event = (0, exports.ns)('event');
exports.agent = (0, exports.ns)('agent');
exports.participant = (0, exports.ns)('participant');
exports.object = (0, exports.ns)('object');
exports.faxNumber = (0, exports.ns)('faxNumber');
exports.email = (0, exports.ns)('email');
exports.legalName = (0, exports.ns)('legalName');
exports.superEvent = (0, exports.ns)('superEvent');
exports.address = (0, exports.ns)('address');
exports.member = (0, exports.ns)('member');
exports.honorificPrefix = (0, exports.ns)('honorificPrefix');
exports.endTime = (0, exports.ns)('endTime');
exports.members = (0, exports.ns)('members');
exports.founder = (0, exports.ns)('founder');
exports.postalCode = (0, exports.ns)('postalCode');
exports.areaServed = (0, exports.ns)('areaServed');
exports.startTime = (0, exports.ns)('startTime');
exports.teamID = (0, exports.ns)('teamID');
exports.parentItem = (0, exports.ns)('parentItem');
exports.usageInfo = (0, exports.ns)('usageInfo');
exports.copyrightNotice = (0, exports.ns)('copyrightNotice');
exports.creditText = (0, exports.ns)('creditText');
exports.value = (0, exports.ns)('value');
exports.propertyID = (0, exports.ns)('propertyID');
exports.variableMeasured = (0, exports.ns)('variableMeasured');
exports.observationDate = (0, exports.ns)('observationDate');
exports.observationAbout = (0, exports.ns)('observationAbout');
exports.item = (0, exports.ns)('item');
exports.dateDeleted = (0, exports.ns)('dateDeleted');
exports.dateModified = (0, exports.ns)('dateModified');
exports.addressCountry = (0, exports.ns)('addressCountry');
exports.addressRegion = (0, exports.ns)('addressRegion');
exports.addressLocality = (0, exports.ns)('addressLocality');
exports.streetAddress = (0, exports.ns)('streetAddress');
exports.schema = {
    // Classes
    Intangible: exports.Intangible,
    DataType: exports.DataType,
    creditText: exports.creditText,
    copyrightNotice: exports.copyrightNotice,
    CreativeWork: exports.CreativeWork,
    usageInfo: exports.usageInfo,
    Person: exports.Person,
    VisualArtwork: exports.VisualArtwork,
    Project: exports.Project,
    PropertyValue: exports.PropertyValue,
    Action: exports.Action,
    ImageObject: exports.ImageObject,
    Code: exports.Code,
    Event: exports.Event,
    JoinAction: exports.JoinAction,
    BefriendAction: exports.BefriendAction,
    Organization: exports.Organization,
    Accommodation: exports.Accommodation,
    Room: exports.Room,
    Apartment: exports.Apartment,
    VideoObject: exports.VideoObject,
    Conversation: exports.Conversation,
    SubscribeAction: exports.SubscribeAction,
    UpdateAction: exports.UpdateAction,
    PlayAction: exports.PlayAction,
    Answer: exports.Answer,
    Comment: exports.Comment,
    Observation: exports.Observation,
    House: exports.House,
    Place: exports.Place,
    City: exports.City,
    Country: exports.Country,
    AdministrativeArea: exports.AdministrativeArea,
    Thing: exports.Thing,
    MediaObject: exports.MediaObject,
    // Properties
    dateModified: exports.dateModified,
    item: exports.item,
    dateDeleted: exports.dateDeleted,
    additionalType: exports.additionalType,
    alternateName: exports.alternateName,
    gender: exports.gender,
    description: exports.description,
    teamID: exports.teamID,
    disambiguatingDescription: exports.disambiguatingDescription,
    identifier: exports.identifier,
    image: exports.image,
    mainEntityOfPage: exports.mainEntityOfPage,
    name: exports.name,
    potentialAction: exports.potentialAction,
    sameAs: exports.sameAs,
    subjectOf: exports.subjectOf,
    url: exports.url,
    artform: exports.artform,
    artist: exports.artist,
    artworkSurface: exports.artworkSurface,
    colorist: exports.colorist,
    depth: exports.depth,
    height: exports.height,
    inker: exports.inker,
    containedInPlace: exports.containedInPlace,
    containsPlace: exports.containsPlace,
    letterer: exports.letterer,
    penciler: exports.penciler,
    observationDate: exports.observationDate,
    variableMeasured: exports.variableMeasured,
    observationAbout: exports.observationAbout,
    width: exports.width,
    artEdition: exports.artEdition,
    artMedium: exports.artMedium,
    dateCreated: exports.dateCreated,
    datePublished: exports.datePublished,
    birthDate: exports.birthDate,
    birthPlace: exports.birthPlace,
    hasOccupation: exports.hasOccupation,
    homeLocation: exports.homeLocation,
    familyName: exports.familyName,
    givenName: exports.givenName,
    propertyID: exports.propertyID,
    codeValue: exports.codeValue,
    contentUrl: exports.contentUrl,
    latitude: exports.latitude,
    longitude: exports.longitude,
    telephone: exports.telephone,
    honorificPrefix: exports.honorificPrefix,
    actionStatus: exports.actionStatus,
    accommodationCategory: exports.accommodationCategory,
    about: exports.about,
    startDate: exports.startDate,
    endDate: exports.endDate,
    affiliation: exports.affiliation,
    attendee: exports.attendee,
    location: exports.location,
    event: exports.event,
    agent: exports.agent,
    participant: exports.participant,
    object: exports.object,
    faxNumber: exports.faxNumber,
    email: exports.email,
    address: exports.address,
    legalName: exports.legalName,
    superEvent: exports.superEvent,
    member: exports.member,
    endTime: exports.endTime,
    members: exports.members,
    founder: exports.founder,
    postalCode: exports.postalCode,
    areaServed: exports.areaServed,
    startTime: exports.startTime,
    parentItem: exports.parentItem,
    value: exports.value,
    addressCountry: exports.addressCountry,
    addressRegion: exports.addressRegion,
    addressLocality: exports.addressLocality,
    streetAddress: exports.streetAddress,
};
(0, package_1.linkedOntology)(_this, exports.ns, 'schema', exports.loadData, [
    '../data/schema.json',
    '../data/schema-added.json',
]);
//# sourceMappingURL=schema.js.map